import { render, staticRenderFns } from "./StudentPaymentReceipt.vue?vue&type=template&id=23c4ffa6&"
import script from "./StudentPaymentReceipt.vue?vue&type=script&lang=js&"
export * from "./StudentPaymentReceipt.vue?vue&type=script&lang=js&"
import style0 from "./StudentPaymentReceipt.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StudentPaymentReceipt.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports